import image1 from '@/assets/images/news/detail/20220316/1.jpeg';
import image2 from '@/assets/images/news/detail/20220316/2.jpeg';
import image3 from '@/assets/images/news/detail/20220316/3.jpeg';
export default {
  id: '20220316', //  模块 id
  title: '四川65岁独臂老人搭上叮咚买菜电商快车，种香椿走上致富路', // 标题
  origin: '2022-03-16 16:30   来源：封面新闻', // 新闻来源
  editor: '编辑：雷强', // 编辑者
  content: [
    {
      type: 0,
      text:
        '“我希望靠自己有尊严地生活，通过自己的劳动挣钱，我觉得很有成就感，生活也充满了意义。”',
      isIndent: true,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text:
        '早上6点，四川省达州市大竹县白羊村，65岁的老人王守国正在地里采摘新露芽的香椿叶。两根一长一短的竹竿，分别负责高低不同的树枝，竹竿上绑着一只用铁丝做成的弯钩，这么一个简单的自制工具，便是老人致富的法宝。用弯钩轻轻一钩，新鲜的香椿芽便从树尖上落下，再把它们小心地捡进竹篓里。',
      isIndent: true,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text:
        '随着气温回暖，大竹县的香椿进入采摘季节。从3月9日开始，王守国老人每天早上都早早地到地里采摘最新鲜的香椿芽。一直忙活到中午，再把新采下的香椿芽送到村里垭口上即时电商叮咚买菜基地采购工作人员的手中。',
      isIndent: true,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text:
        '每年春天，香椿都是最具代表性与讨论热度的春味之一，而大竹县又被称为“中国香椿第一县”。地处四川东部典型的三山两槽地形，大竹县常年雨量充沛，依靠独特的地理环境优势，大竹香椿色彩红亮，叶片肥厚，水分含量大，拥有更加鲜嫩的口感以及丰富的花青素。',
      isIndent: true,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text:
        '16年前，在外地打工的王守国因为意外而失去了一只手臂。无奈之下，只好回到大竹县老家，原本希望继续打工，在县城里做一些类似安保之类的简单工作，但都因为残疾碰了壁。于是，王守国回到村里，依靠种稻谷、玉米和养几只猪和牛生活。',
      isIndent: true,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text:
        '可是，随着年龄的增长，种稻谷和玉米，插秧、割草、施肥等繁琐的工作对于只有一只手的王守国来说，变得越来越困难。2017年，在政府的号召与帮助下，王守国开始尝试种植香椿。',
      isIndent: true,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text:
        '起初，王守国只在家中院子中种了两棵香椿树。很快他发现，种香椿比种庄稼简单，仅春天一两个月的时间，就可以收获两三茬香椿芽，香椿树新抽出的枝，还可以轻松移植，成长为另一棵茂密的香椿树。种植和采摘也相对其它庄稼更加简单，尽管只有一只手，也可以熟练操作。        ',
      isIndent: true,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text:
        '一天，王守国将早晨新鲜采摘的香椿芽送到镇上去卖，一上午便挣到了500块钱。这可把他高兴坏了，他更加坚定要继续种植香椿的念头。重要的是，通过自己自强不息，努力奋斗而换取的报酬，让王守国感受到深深的自豪。那一刻，他不再为身体残疾而灰心丧气，他相信靠自己的努力也可以过上好的生活。',
      isIndent: true,
    },    {
      type: 2,
    },
    {
      type: 0,
      text:
        '于是，王守国坚定地走上了香椿种植的道路，从最初的2棵香椿树，慢慢将家里3亩多地全部种上了香椿。随着当地香椿产业化发展以及叮咚买菜等电商平台的扶持，王守国说：“这两年我的香椿完全不愁销路，每年靠香椿就可以稳定收入四五万元。去年，我终于摘下了贫困户的帽子，还靠积蓄帮助儿子在县城买了房。尽管只有一只手，但我依然有能力靠自己有尊严地生活，还把生活越过越好。”        ',
      isIndent: true,
    },    {
      type: 2,
    },
    {
      type: 0,
      text:
        '据了解，目前大竹香椿产业在全县已经发展有将近12万亩，占到全国香椿总产量的三成。“大竹县在2009年左右便开始着力发展香椿产业，但因为农业数字化程度低，经营方式粗放，香椿的品质参差不齐，价格一直上不去，销售的过程中损耗也很高。”大竹县香椿产业协会会长刘成文介绍，“近两年，随着与叮咚买菜等生鲜电商合作，当地香椿产业完成了数字化、标准化的转变，香椿品质大幅提升，价格也更加稳定。目前，大竹香椿的销售渠道中，电商已占到20%左右的比例。”',
      isIndent: true,
    },    {
      type: 2,
    },
    {
      type: 0,
      text:
        '据刘成文介绍，叮咚买菜通过订单农业的形式，在每年香椿种植之前，就下好订单、定好需求，农户再根据需求来确定产能，这样的形式切实保障了农户收入的稳定，同时，也对大竹香椿品质的标准化、数字化生产和管理提出了更高的要求。目前大竹香椿产业已建立追溯系统，数字化监测香椿生长环境的温度、湿度、土壤水分等，香椿的仓储、运输、销售环节也都实现了数字化管控。',
      isIndent: true,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text:
        '据了解，作为叮咚买菜乡村振兴“绿水青山”计划的重要品类，今年叮咚买菜大竹香椿产地直采规模将达到近1000万元。同时，通过全程冷链运输，大竹香椿将通过叮咚买菜售向全国，助力大竹香椿品牌化发展，帮助更多像王守国一样的农户过上更好的生活。',
      isIndent: true,
    },
  ],
};
